import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 30vw;
  height: 45vh;

  background-color: white;

  padding: 2rem 1rem;

  align-items: center;
  justify-content: center;

  border-radius: 0.4rem;

  position: relative;

  .message-content {
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    gap: 1rem;
  }

  .message-img {
    width: 4rem;
    height: 4rem;

    color: #3715ff;
  }

  .message-text {
    font-size: 1.2rem;
    font-weight: 600;
  }

  .footer-wrapper {
    position: absolute;

    bottom: 1rem;

    text-align: center;
  }

  .button {
    width: 5rem;
    height: 2.5rem;

    border: 1px solid #3715ff;
    border-radius: 0.4rem;

    background: none;

    font-size: 1.2rem;

    color: #3715ff;

    cursor: pointer;
  }

  .circular {
    height: 6.25rem;
    width: 6.25rem;

    position: relative;
  }

  .circular .inner {
    position: absolute;

    z-index: 6;

    top: 50%;
    left: 50%;

    height: 5rem;
    width: 5rem;

    margin: -2.5rem 0 0 -2.5rem;

    background: #3715ff;

    border-radius: 100%;
  }

  .circular .number {
    position: absolute;

    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);

    z-index: 10;

    font-size: 1.2rem;
    font-weight: 500;

    color: white;
  }

  .circular .bar {
    position: absolute;

    height: 100%;
    width: 100%;

    background: #fff;

    border-radius: 100%;

    clip: rect(0rem, 7rem, 7rem, 2.5rem);
  }

  .circle .bar .progress {
    position: absolute;

    height: 100%;
    width: 100%;

    border-radius: 100%;

    clip: rect(0rem, 2.5rem, 7rem, 0rem);

    background-color: #3715ff;
  }

  .circular .left .progress {
    z-index: 1;

    animation: left 0.5s linear both;
  }

  @keyframes left {
    100% {
      transform: rotate(180deg);
    }
  }

  .circle .right {
    transform: rotate(180deg);

    z-index: 3;
  }

  .circle .right .progress {
    animation: right 0.5s linear both;
    animation-delay: 0.5s;
  }

  @keyframes right {
    100% {
      transform: rotate(180deg);
    }
  }
`;
